import { render } from "./UiPropPanelStyle.vue?vue&type=template&id=57e2aff2"
import script from "./UiPropPanelStyle.vue?vue&type=script&lang=js"
export * from "./UiPropPanelStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__